"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _BrixelButtonIcon = _interopRequireDefault(require("../BrixelButtonIcon"));
var _helper = require("../../utils/helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// eslint-disable-next-line react/display-name
const BrixelUploadFile = props => {
  const {
    acceptedFile = [],
    className = '',
    disabled = false,
    hideFileDescription = false,
    input,
    label = '',
    labelButton = 'Upload',
    theme = 'full',
    labelIcon = false
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(null);
  const btnRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if ((0, _get.default)(input, 'value.name', null)) {
      setCurrentValue((0, _get.default)(input, 'value.name', ''));
    } else if (input.value) (0, _get.default)(input, 'value', '');
  }, [input.value]);
  const uploadBtnEvent = e => {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      e.target.click();
      e.target.classList.add('active');
    }
  };
  // keyboard accessablitly
  (0, _react.useEffect)(() => {
    const btnEl = btnRef.current;
    if (btnEl) btnEl.addEventListener('keydown', uploadBtnEvent, false);
  }, [btnRef]);
  const saveFile = async e => {
    if (!disabled) {
      const file = e.target.files[0];
      const convertedFile = await (0, _helper.toBase64)(file);
      if (convertedFile && (0, _get.default)(convertedFile, 'name', null)) {
        setCurrentValue((0, _get.default)(convertedFile, 'name', null));
        if (input.onChange) input.onChange(convertedFile);
      }
    }
  };
  const deleteFile = () => {
    setCurrentValue(null);
    if (input.onChange) input.onChange(input.value);
    if (input.onRemove) input.onRemove(input.value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-upload-file ${className} ${disabled ? 'disabled' : ''}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label mb-0"
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: currentValue ? 'dis-fl-col' : 'dis-f'
  }, currentValue ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f jc-b a-c"
  }, !hideFileDescription && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c"
  }, theme === 'full' && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    background: "primary",
    saturation: 100,
    color: "primary",
    saturationTxt: 700,
    icon: "document"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "txtText900 px-small-12 tt-break max-w-fix-304 max-w-fix-sm-504"
  }, currentValue))), theme === 'full' && (/*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    ghost: true,
    theme: "red",
    icon: "bin",
    onClick: () => deleteFile()
  }))))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, theme === 'full' && (/*#__PURE__*/_react.default.createElement("label", {
    ref: btnRef,
    htmlFor: input.name,
    className: "secondaryBtn brdPrimary400 txtPrimary400 bgWhite rounded ta-c"
  }, labelIcon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "mr-2",
    color: "green",
    icon: "upload"
  })), labelButton)), theme === 'simple' && (/*#__PURE__*/_react.default.createElement("label", {
    ref: btnRef,
    htmlFor: input.name,
    className: "txtPrimary400"
  }, labelButton)), /*#__PURE__*/_react.default.createElement("input", {
    disabled: disabled,
    type: "file",
    name: input.name,
    id: input.name,
    onChange: e => saveFile(e),
    accept: acceptedFile.join(', ')
  })))));
};
var _default = exports.default = BrixelUploadFile;